// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ta: ChromeTranslations = {
  'nav.nextPage': 'அடுத்த பக்கம் →',
  'nav.previousPage': '← முந்தைய பக்கம்',
  'nav.continueToLevel': 'நிலைக்கு தொடரு →',
  'nav.backToMenu': 'மெனுவுக்கு திரும்பு →',
  'howto.page': '{total}-இல் பக்கம் {n}',
  'options.title': 'விருப்பங்கள்',
  'ui.language': 'மொழி',
};
